'use client';

import Separator from '@/src/components/clean/Separator/Separator';
import { useCheckIsMobileView } from '@/src/v2/hooks/useCheckIsMobileView/useCheckIsMobileView';
import classNames from 'classnames';
import React, {
  FC,
  PropsWithChildren,
  ReactNode,
  useEffect,
  useState,
} from 'react';
import ReactDOM from 'react-dom';
import { AiOutlineClose } from '../../assets/third-party';

import style from './modal.module.scss';

type Props = {
  title: string | ReactNode;
  isSubscription?: boolean;
  width?: string;
  height?: string;
  onClose: () => void;
  show: boolean;
  isScrollable?: boolean;
  className?: string;
  hideHeader?: boolean;
  paddingZero?: boolean;
  validateIsBrowser?: boolean;
  isPayPerView?: boolean;
};

const Modal: FC<PropsWithChildren<Props>> = ({
  show,
  onClose,
  children,
  title,
  isSubscription = false,
  isPayPerView = false,
  width,
  height,
  isScrollable = false,
  className,
  hideHeader = false,
  paddingZero = false,
  validateIsBrowser = true,
}) => {
  const [isBrowser, setIsBrowser] = useState(false);
  const { isMobileView } = useCheckIsMobileView();

  useEffect(() => {
    setIsBrowser(true);
  }, []);

  const modalContent = validateIsBrowser ? (
    show ? (
      <div className={classNames(style['modal__overlay'], style[className])}>
        <div
          className={classNames(
            style[`${className}__container`],
            style['modal__container'],
            {
              [style['modal__container--paddingZero']]: paddingZero,
            },
            {
              [style['modal__container--mobile']]:
                isMobileView && !isSubscription,
            },
            {
              [style['modal__container--scrollable']]: isScrollable,
            },
            {
              [style['modal__container--ppv']]: isPayPerView,
            },
            {
              [style['modal__container--subscribe']]: isSubscription,
            }
          )}
          style={{ width: width && width }}
        >
          {!hideHeader && (
            <>
              <div
                className={classNames(style[`modal__container__header`], {
                  [style['modal__container__header--ppv']]:
                    isPayPerView || isSubscription,
                })}
                style={title == 'Subscribe' ? { marginBottom: '1rem' } : {}}
              >
                <>{title}</>
                {title != 'Complete Signup' && (
                  <AiOutlineClose
                    onClick={onClose}
                    className={style['modal__close']}
                  />
                )}
              </div>
              {/* {title != 'Pay Per View' ||
                (title != 'Complete Your Purchase' && <Separator />)} */}
            </>
          )}
          <div id="modal-content">{children}</div>
        </div>
      </div>
    ) : null
  ) : (
    <div
      style={{ visibility: show ? 'visible' : 'hidden' }}
      className={classNames(style['modal__overlay'], style[className])}
    >
      <div
        className={classNames(
          style[`${className}__container`],
          {
            [style['modal__container--paddingZero']]: paddingZero,
          },
          {
            [style['modal__container--mobile']]:
              isMobileView && !isSubscription,
          },
          style['modal__container'],
          {
            [style['modal__container--scrollable']]: isScrollable,
          }
        )}
      >
        {!hideHeader && (
          <>
            <div className={classNames(style[`modal__container__header`])}>
              <>{title}</>
              {title !== 'Complete Signup' && (
                <AiOutlineClose
                  onClick={onClose}
                  className={style['modal__close']}
                />
              )}
            </div>
          </>
        )}
        <div
          id="modal-content-auth"
          style={{ display: show ? 'block' : 'none' }}
        >
          {children}
        </div>
      </div>
    </div>
  );
  const createPorta = () => {
    return ReactDOM.createPortal(
      modalContent,
      document.getElementById('modal-root')
    );
  };
  if (validateIsBrowser) {
    if (isBrowser) {
      return createPorta();
    } else {
      return null;
    }
  }
  return createPorta();
};

export default Modal;
